import React from "react";

const DialogoMostrarTelefonos = (params) => {
  return (
    <div
      id="dialogoMostrarTelefonos"
      className="modal"
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 style={{ textAlign: "center", fontWeight: "bold" }}>
              Télefonos
            </h5>
            <svg
              data-dismiss="modal"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-x-square"
              viewBox="0 0 16 16"
              style={{ marginTop: "-0.8em", cursor: "pointer" }}
            >
              <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
            </svg>
          </div>
          <div style={{ textAlign: "center" }} className="modal-body">
            {params.telefonos.map((item, index) => {
              return <li data-dismiss="modal" onClick={()=>params.seleccionarTelefono(item)} key={index}>{item}</li>;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialogoMostrarTelefonos;
